import PdvAtualizacaoService from "@/services/PdvAtualizacaoService";

export const pdvAtualizacao = {
  namespaced: true,
  state: {
    configuracao: {},
  },
  actions: {
    getConfiguracaoPdvAtualizacao() {
      return PdvAtualizacaoService.GetConfiguracao().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postReleasePdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.PostRelease(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putReleasePdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.PutRelease(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteReleasePdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.DeleteRelease(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    publicarReleasePdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.PublicarRelease(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    uploadInstaladorPdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.UploadInstalador(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postArquivoPdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.PostArquivo(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putArquivoPdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.PutArquivo(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteArquivoPdvAtualizacao({ commit }, payload) {
      return PdvAtualizacaoService.DeleteArquivo(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default pdvAtualizacao;
